// CSV export utilities.
// One row per line-item so the file can be pasted straight into a
// supplier/purchase sheet.
import { AREA_BY_ID, RESTAURANT_BY_ID } from "../constants";

const HEADERS = [
  "Date",
  "Type",
  "Status",
  "Restaurant",
  "From",
  "To",
  "Vendor",
  "Vendor type",
  "Requester",
  "Role",
  "Areas",
  "Product",
  "Category",
  "Quantity",
  "Unit",
  "Line note",
  "Request note",
  "Request ID",
];

function escapeCell(value) {
  if (value === null || value === undefined) return "";
  const s = String(value);
  if (/[",\n\r]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
}

function areaLabelsFor(request) {
  const ids =
    request.requesterAreas && request.requesterAreas.length > 0
      ? request.requesterAreas
      : request.requesterArea
      ? [request.requesterArea]
      : [];
  return ids.map((a) => AREA_BY_ID[a]?.name).filter(Boolean).join(" / ");
}

export function requestsToCsvRows(requests, products, suppliers) {
  const productById = new Map(products.map((p) => [p.id, p]));
  const supplierById = new Map(suppliers.map((s) => [s.id, s]));
  const rows = [HEADERS];
  requests.forEach((r) => {
    const supplier = r.vendor ? supplierById.get(r.vendor) : null;
    const isTransfer = r.type === "internal_transfer";
    const restName = RESTAURANT_BY_ID[r.restaurant]?.name || "";
    const fromName = isTransfer ? RESTAURANT_BY_ID[r.fromRestaurant]?.name || "" : "";
    const toName = isTransfer ? RESTAURANT_BY_ID[r.toRestaurant]?.name || "" : "";
    const items = r.items && r.items.length > 0 ? r.items : [{}];
    items.forEach((it) => {
      const product = it.productId ? productById.get(it.productId) : null;
      rows.push([
        r.createdAt ? new Date(r.createdAt).toISOString() : "",
        isTransfer ? "Internal transfer" : "Purchase",
        r.status || "",
        restName,
        fromName,
        toName,
        supplier?.name || "",
        supplier?.type || "",
        r.requestedByName || "",
        r.requesterRole || "",
        areaLabelsFor(r),
        product?.name || it.productName || "",
        product?.category || "",
        it.quantity ?? it.qty ?? "",
        it.unit || product?.unit || "",
        it.note || "",
        r.notes || "",
        r.id || "",
      ]);
    });
  });
  return rows;
}

export function rowsToCsv(rows) {
  return rows.map((row) => row.map(escapeCell).join(",")).join("\r\n");
}

export function downloadCsv(filename, rows) {
  // Prefix BOM so Excel opens UTF-8 correctly.
  const csv = "\uFEFF" + rowsToCsv(rows);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

const FILENAME_SUFFIX = {
  transfer: "transfers",
  purchase: "purchases",
  finance: "finance",
};

export function buildCsvFilename(scope) {
  const d = new Date();
  const iso = d.toISOString().slice(0, 10);
  const suffix = FILENAME_SUFFIX[scope] || "requests";
  return `cafe-breizh-${suffix}-${iso}.csv`;
}
